<template>
  <div id="app2">
    Type : 
    <div class="event_types">
      <label class="event_type event_type_0">
        <input type="radio" v-model="eventType" value="0" /> Tous<span></span>
      </labeL>
      <label class="event_type event_type_10">
        <input type="radio" v-model="eventType" value="10" /> Cours<span></span>
      </labeL>
      <label class="event_type event_type_6">
        <input type="radio" v-model="eventType" value="6" /> Divers<span></span>
      </labeL>
      <label class="event_type event_type_5">
        <input type="radio" v-model="eventType" value="5" /> Formation ATE/CRE<span></span>
      </labeL>
      <label class="event_type event_type_9">
        <input type="radio" v-model="eventType" value="9" /> Rallye<span></span>
      </labeL>
      <label class="event_type event_type_7">
        <input type="radio" v-model="eventType" value="7" /> Randonnée<span></span>
      </labeL>
      <label class="event_type event_type_8">
        <input type="radio" v-model="eventType" value="8" /> Trec<span></span>
      </labeL>
    </div>
    <br />
    <calendar-view
        :show-date="showDate"
        locale='fr'
        :starting-day-of-week=1
        :events="events2"
        :period-changed-callback="load_events"
        @click-event="onClickItem"
        class="theme-default holiday-us-traditional holiday-us-official">
        
        <calendar-view-header
            slot="header"
            slot-scope="t"
            :header-props="t.headerProps"
            @input="setShowDate" />
            
    </calendar-view>
    <div v-if="eventShow" class="asre_event_container">
      <div class="asre_event">
        <button class="asre_event_close" @click="eventShow=false;">X</button>
        <h2 v-html="decodedHTMLContent(event.title)" ></h2>
        <h3>{{getType(event.type)}}</h3>
        <h4>{{event.localite}} - {{event.canton}}</h4>
        <p>
          Du : {{event.date_debut}} au : {{event.date_fin}}<br />
          <span v-if="event.open">Inscription ouverte du : {{event.date_insc_debut}} au : {{event.date_insc_fin}}<br /></span>
          <span v-if="event.adresse!=''">Adresse : {{event.adresse}}<br /></span>
          <span v-if="event.tel!=''">Tel : {{event.tel}}<br /></span>
          <span v-if="event.email!=''">Email : <a :href="'mailto:'+event.email">{{event.email}}</a><br /></span>
          <br />
          <span v-if="event.series.length>0">Séries : {{event.series.join(', ')}}</span>
        </p>
        <a :href="event.url" class="button">Voir les détails de l'événement</a>
      </div>
    </div>
  </div>
</template>

<script>

import { CalendarView, CalendarViewHeader } from "vue-simple-calendar"
require("vue-simple-calendar/static/css/default.css")
require("vue-simple-calendar/static/css/holidays-us.css")

export default {
  name: 'App',
  
  components: {
    CalendarView,
    CalendarViewHeader,
  },
  data: () => ({
    showDate: new Date(),
    eventType:0,
    events:[],
    event: {},
    eventShow: false
  }),
  computed:{
    events2(){
      let events = [];
      this.events.map(function(e){
        if(this.eventType==0 || e.type==this.eventType){
          events.push(e);
        }
        else{
          return false;
        }
      }.bind(this));
      return events;
    }
    
  },
  methods: {
      decodedHTMLContent(h) {
        const container = document.createElement('div');
        container.innerHTML = h;
        return container.innerHTML;
      },
      setShowDate(d) {
          this.showDate = d;
      },
      getType(type){
        switch (type) {
          case 10:
            return 'Cours';
          case 6:
            return 'Divers';
          case 5:
            return 'Formation ATE/CRE';
          case 9:
            return 'Rallye';
          case 7:
            return 'Randonnée';
          case 8:
            return 'TREC';
        }
        
      },
      async load_events(range){
        
        try {
          var dateStart = new Date(range.displayFirstDate.getTime());
          dateStart.setDate(dateStart.getDate() - 90);
          var dateEnd = new Date(range.displayLastDate.getTime());
          dateEnd.setDate(dateEnd.getDate() + 90);
          let response = await window.axios.get('/wp-json/wp/v2/evenement?per_page=100&date_debut='+dateStart.toISOString().slice(0,10)+'&date_fin='+dateEnd.toISOString().slice(0,10));
          //let response = await window.axios.get('/evenements.json?per_page=100&date_debut='+dateStart.toISOString().slice(0,10)+'&date_fin='+dateEnd.toISOString().slice(0,10));
          console.log(response.data);
          var events = [];
          for(var key in response.data){
            var event = response.data[key];  
            var ev={};
            ev.id='event-'+event.id;
            ev.title = event.title.rendered;
            ev.type = event.ACF.type_event;
            ev.series = event.ACF.series;
            ev.open = event.ACF.ouvert_aux_inscriptions;
            ev.localite = event.ACF.localite;
            ev.email = event.ACF.email;
            ev.canton = event.ACF.canton_pays;
            ev.adresse = event.ACF.adresse;
            ev.tel = event.ACF.telephone;
            ev.classes = "event_type_"+ev.type;
            ev.url = event.link;
            ev.date_debut = event.ACF.date_de_debut;
            ev.date_fin = event.ACF.date_de_fin;
            ev.date_insc_debut = event.ACF.date_debut_dinscription;
            ev.date_insc_fin = event.ACF.date_fin_dinscription;
            // regex for start and finish date :
            var dates = event.ACF.date_de_debut.match(/^([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{2,4})$/);
            ev.startDate = new Date(parseInt(dates[3]),(parseInt(dates[2])-1),parseInt(dates[1]));
            var dates2 = event.ACF.date_de_fin.match(/^([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{2,4})$/);
            if(event.ACF.ouvert_aux_inscriptions){
              ev.endDate = new Date(parseInt(dates2[3]),(parseInt(dates2[2])-1),parseInt(dates2[1]),23,59);
              var dates3 = event.ACF.date_debut_dinscription.match(/^([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{2,4})$/);
              ev.debutInscription = new Date(parseInt(dates3[3]),(parseInt(dates3[2])-1),parseInt(dates3[1]),23,59);
              var dates4 = event.ACF.date_fin_dinscription.match(/^([0-9]{1,2})\/([0-9]{1,2})\/([0-9]{2,4})$/);
              ev.finInscription = new Date(parseInt(dates4[3]),(parseInt(dates4[2])-1),parseInt(dates4[1]),23,59);
            }
            events.push(ev);
          }
          //console.log(events);
          this.events = events;
        } catch (error){
          console.log(error);
          console.log('error loading events');
        }

      },
      onClickItem(e){
        this.event = e.originalEvent;
        this.eventShow=true;
      }
  },
  created: function(){
    console.log(window.asre_calendar_type);
    if(window.asre_calendar_type!==undefined){
      this.eventType=window.asre_calendar_type;
    }
  }

};
</script>
<style>
  .event_types{
    display: flex;
  }
  .event_type{
    width: calc((100% / 7) - 4px);
    margin: 2px;
    border: 1px solid #000;
    padding: 4px;
  }
    #app2 {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        color: #2c3e50;
        height: auto;
        width: 90%;
        margin-left: auto;
        margin-right: auto;
    }
    .asre_event_container{
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,.5);
      z-index: 10000;
    }
    .asre_event{
      position: relative;
      margin: auto;
      top: calc((100vh - 450px) / 2);
      min-width: 300px;
      max-width: 450px;
      max-height: 450px;
      padding: 15px;
      background-color: #FFF;
      border: 2px solid #000;
      border-radius: 25px;
    }
    .asre_event h2{
      margin: 0 0 5px 0;
      font-size: 18px;
    }
    .asre_event h3{
      margin: 0 0 5px 0;
      font-size: 14px;
    }
    .asre_event h4{
      margin: 0 0 5px 0;
      font-size: 13px;
      font-weight: normal;
    }
    .asre_event p{
      margin: 0 0 10px 0;
      font-size: 12px;
    }
    .asre_event_close{
      position: absolute;
      top: 5px;
      right: 15px;
      line-height: 25px;
      width: 25px;
      height: 25px;
      text-align: center;
      cursor: pointer;
      border-radius: 25px;
    }
    #event {

    }
</style>
